@if (aboveTop.length) {
  <div class="mobile-above-top">
    @for (item of aboveTop; track item) {
      <div class="above-top-item">
        @if (item.is_active) {
          <div>
            <template [ngTemplateOutlet]="switchItem" [ngTemplateOutletContext]="{item:item}"></template>
          </div>
        }
      </div>
    }
  </div>
}
<div class="mobile-top">
  <ul class="nav nav-fill p-0">
    @if (!isOpen) {
      <li class="nav-item d-flex align-items-center justify-content-center" (click)="init($event)">
        <a routerLink="/{{logo?.link}}">
          <img [src]="logo?.collapsed?.icon" alt="{{logo?.title|translate}}">
        </a>
      </li>
    }
    @if (isOpen) {
      <li class="nav-item d-flex align-items-center justify-content-center" (click)="init($event)">
        <img [src]="logo?.expanded?.icon" alt="{{logo?.title|translate}}">
      </li>
    }
    @for (item of top; track item) {
      <li
        class="nav-item mobile-links-items d-flex align-items-center justify-content-center">
        @if (item.is_active) {
          <div>
            <template [ngTemplateOutlet]="switchItem" [ngTemplateOutletContext]="{item:item}"></template>
          </div>
        }
      </li>
    }
    <li class="nav-item d-flex align-items-center justify-content-center">
      <button class="btn-collapse bg-transparent border-0"
        (click)="sidebarToggle()">
        <i class="fa fa-bars"></i>
      </button>
    </li>
  </ul>
</div>
@if (belowTop.length) {
  <div class="mobile-below-top">
    @for (item of belowTop; track item) {
      <div class="below-top-item">
        @if (item.is_active) {
          <div>
            <template [ngTemplateOutlet]="switchItem" [ngTemplateOutletContext]="{item:item}"></template>
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #switchItem let-item="item">
  <!-- components -->
  <div>
    @switch (item.type) {
      @case ('component') {
        <div>
          @if (item.link == 'user-login') {
            <div
              class="login-wrap inwards-menu">
              <user-login libMobileTopAppender [account]=account></user-login>
            </div>
          }
          @if (item.link == 'main-header-cart') {
            <div
              class="cart-wrap">
              <main-header-cart></main-header-cart>
              <!--<main-header-media-cart *ngIf="isDam"></main-header-media-cart>-->
            </div>
          }
          @if (item.link == 'main-header-search-form') {
            <div
              class="search-wrap">
              <main-header-search-form></main-header-search-form>
            </div>
          }
        </div>
      }
      <!-- /components -->
      <!-- links -->
      @case ('link') {
        <a
          routerLink="item.link"
          translate>
          <i [ngClass]="item.icon"></i> {{item.title}}
        </a>
      }
      <!-- /links -->
      <!--ngx-components-->
      @case ('ngx-component') {
        <div>
          <div [ngClass]="item.class" [innerHTML]="item.link | safe: 'html'"></div>
        </div>
      }
    }
  </div>
  <!--/ngx-components-->
</ng-template>
